module.exports = __webpack_public_path__ + "static/media/edit.b0e2216c.svg";